<div class="main-content">
  <div class="container-fluid">
      <div class="col-md-12">
          <div class="card">
              <div class="card-header card-header-danger">
                  <h4 class="card-title">Test Results</h4>
              </div>
              <div class="card-body">
                <form [formGroup]="AddTestResultForm">
                  <div class="row">
                    <div class="col-md-6 mt-3">
                      <div class="form-group"
                      >
                        <label>Items <span style="color: red !important;">*</span> </label>
                        <ng-select  class="form-control" [items]="items" 
                        bindLabel="name" 
                        bindValue="id" 
                        formControlName="ItemId"  
                        >
                      </ng-select>
                      <mat-error class="mt-2"
                      *ngIf="fc.ItemId.invalid && (fc.ItemId.dirty || fc.ItemId.touched)">
                      Item is required
                  </mat-error>
                      </div>
                  
                    </div>
                    <div class="col-md-6 mt-3">
                      <div class="form-group"
                      >
                        <label>Category <span style="color: red !important;">*</span></label>
                        <ng-select  class="form-control" [items]="categories" 
                        bindLabel="name" 
                        bindValue="id" 
                        (change)="GetTestsByCatId($event.id)"
                        formControlName="CategoryId"  
                        >
                      </ng-select>
                      <mat-error class="mt-2"
                      *ngIf="fc.CategoryId.invalid && (fc.CategoryId.dirty || fc.CategoryId.touched)">
                      Category is required
                  </mat-error>
                      </div>
                  
                    </div>
                    <div class="col-md-6 mt-3">
                      <div class="form-group"
                      >
                        <label>Tests <span style="color: red !important;">*</span></label>
                        <ng-select  class="form-control" [items]="filteredTests" 
                        bindLabel="name" 
                        bindValue="id" 
                        formControlName="TestId"  
                        >
                      </ng-select>
                      <mat-error class="mt-2"
                      *ngIf="fc.TestId.invalid && (fc.TestId.dirty || fc.TestId.touched)">
                      Test is required
                  </mat-error>
                      </div>
                  
                    </div>
                    <div class="col-md-6 mt-3">
                      <div class="form-group"
                      >
                        <label>Result <span style="color: red !important;">*</span></label>
                        <ng-select  class="form-control" [items]="result" 
                        bindLabel="name" 
                        bindValue="value" 
                        formControlName="Result"  
                        >
                      </ng-select>
                      <mat-error class="mt-2"
                      *ngIf="fc.Result.invalid && (fc.Result.dirty || fc.Result.touched)">
                      Result is required
                  </mat-error>
                      </div>
                  
                    </div>
                    <div class="col-md-6 mt-3">
                      <div class="form-group"
                      >
                        <label>Branches  <span style="color: red !important;">*</span> </label>
                        <ng-select  class="form-control" [items]="AllBranchs" 
                        bindLabel="name" 
                        bindValue="id" 
                        formControlName="Branch"  
                        >
                      </ng-select>
                      <mat-error class="mt-2"
                      *ngIf="fc.Branch.invalid && (fc.Branch.dirty || fc.Branch.touched)">
                      Branch is required
                  </mat-error>
                      </div>
                  
                    </div>
                    <div class="col-md-6">
                      <mat-form-field class="DateMt">
                          <input matInput [matDatepicker]="dateResult"  formControlName="DateResult"   name="dateResult" required
                              placeholder="Result Date">
                          <mat-datepicker-toggle matSuffix [for]="dateResult"></mat-datepicker-toggle>
                          <mat-datepicker #dateResult></mat-datepicker>
                          <mat-error class="mt-2"
                              *ngIf="fc.DateResult.invalid && (fc.DateResult.dirty || fc.DateResult.touched)">
                              Date Result is required
                          </mat-error>
                      </mat-form-field>
                  </div>
                  <div class="col-md-12">
                    <mat-form-field>
                        <textarea matInput  formControlName="Notes" maxLength="100"   name="dateResult" 
                            placeholder="Notes"></textarea>
                       
                    </mat-form-field>
                </div>
                  </div>
                  <button mat-raised-button type="submit"  class="btn primary pull-right" [disabled]="AddTestResultForm.invalid"  (click)="Submit()">Add Result</button>
                              <div class="clearfix"></div>
                </form>
              </div>
          </div>
      </div>
  </div>
</div>